import { defineMessages } from 'react-intl';

export const TOOLBAR_MESSAGES = defineMessages({
  chartToolbarMove: {
    id: 'Rx7WtBPx/tyQ5h+j',
    defaultMessage: 'Move',
    description:
      'Text in a tooltip shown when hovering "Move" action in the time series chart toolbar',
  },
  chartToolbarCollapse: {
    id: 'dTJ8Pdj8Xm9Uh9Y+',
    defaultMessage: 'Collapse toolbar',
    description:
      'Text in a tooltip shown when hovering "Collapse" action in the time series chart toolbar',
  },
  chartToolbarExpand: {
    id: 'Y0Ru/2gdHx6uuwvl',
    defaultMessage: 'Expand toolbar',
    description:
      'Text in a tooltip shown when hovering "Expand" action in the time series chart toolbar',
  },
  downloadDataButton: {
    id: 'f4/NcUWxDYnAQ68s',
    defaultMessage: 'Download as CSV',
    description: 'Text in "Download data" button in the chart toolbar',
  },
  downloadData: {
    id: 'u5xmuzxNDovVbbQX',
    defaultMessage: 'Download as CSV',
    description:
      'Text in a tooltip shown when hovering the "Download data" button in the time series chart toolbar',
  },
  moreOptions: {
    id: 'eONO7S5ZXY7V+R6d',
    defaultMessage: 'More options',
    description:
      'Text in button that opens a menu with more actions in the chart toolbar',
  },
  changeMode: {
    id: 'uDo0yY4voNQ3eiN7',
    defaultMessage: 'Change mode',
    description:
      "Text in a tooltip shown when hovering the expanded toolbar's menu button in the time series chart toolbar",
  },
  chartTools: {
    id: 'LgOM6mSxWTUB+NI/',
    defaultMessage: 'Chart tools',
    description:
      "Text in a tooltip shown when hovering the manually collapsed toolbar's menu button in the time series chart toolbar",
  },
  or: {
    id: 'S3llhud3ydpS6ObI',
    defaultMessage: 'or',
    description: 'or',
  },
});
